import * as db from './db';

const NOTIF_KEY = 'betbuds_notifications';

function getStored() {
  const stored = localStorage.getItem(NOTIF_KEY);
  if (stored) return JSON.parse(stored);
  localStorage.setItem(NOTIF_KEY, JSON.stringify([]));
  return [];
}

function save(data) {
  localStorage.setItem(NOTIF_KEY, JSON.stringify(data.slice(-200)));
}

function dbWrite(promise) {
  promise.catch((err) => console.warn('[notifications] DynamoDB write failed:', err));
}

export const notificationsService = {
  getForUser(userId, limit = 20) {
    return getStored()
      .filter((n) => n.userId === userId)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, limit);
  },

  getUnreadCount(userId) {
    return getStored().filter((n) => n.userId === userId && !n.read).length;
  },

  create({ userId, type, title, body, masterEventId, activityId, link }) {
    const notifs = getStored();
    const notif = {
      id: `notif_${Date.now()}_${Math.random().toString(36).slice(2, 5)}`,
      userId,
      type: type || 'general',
      title,
      body: body || '',
      masterEventId: masterEventId || null,
      activityId: activityId || null,
      link: link || null,
      read: false,
      createdAt: new Date().toISOString(),
    };
    notifs.push(notif);
    save(notifs);

    // DynamoDB dual-write
    dbWrite(db.createNotification({
      notificationId: notif.id,
      userId: notif.userId,
      type: notif.type,
      title: notif.title,
      body: notif.body,
      masterEventId: notif.masterEventId,
      activityId: notif.activityId,
      link: notif.link,
      read: false,
    }));

    return notif;
  },

  markRead(notifId) {
    const notifs = getStored();
    const n = notifs.find((x) => x.id === notifId);
    if (n) {
      n.read = true;
      save(notifs);

      // DynamoDB dual-write
      dbWrite(db.updateNotification(notifId, { read: true }));
    }
  },

  markAllRead(userId) {
    const notifs = getStored();
    notifs.forEach((n) => {
      if (n.userId === userId && !n.read) {
        n.read = true;
        // DynamoDB dual-write per notification
        dbWrite(db.updateNotification(n.id, { read: true }));
      }
    });
    save(notifs);
  },

  // Create notifications for @ mentions in text
  notifyMentions({ text, fromUserId, fromName, allUsers, masterEventId, activityId, link }) {
    const mentionRegex = /@(\w+)/g;
    let match;
    while ((match = mentionRegex.exec(text)) !== null) {
      const mentionedName = match[1].toLowerCase();
      const target = allUsers.find(
        (u) => u.displayName?.toLowerCase() === mentionedName || u.username?.toLowerCase() === mentionedName
      );
      if (target && target.id !== fromUserId) {
        this.create({
          userId: target.id,
          type: 'mention',
          title: `${fromName} mentioned you`,
          body: text.length > 80 ? text.slice(0, 80) + '...' : text,
          masterEventId,
          activityId,
          link,
        });
      }
    }
  },

  // Create notification for an activity update
  notifyActivity({ userIds, type, title, body, masterEventId, activityId, link, excludeUserId }) {
    userIds.forEach((uid) => {
      if (uid !== excludeUserId) {
        this.create({ userId: uid, type, title, body, masterEventId, activityId, link });
      }
    });
  },
};
